import React, { ReactNode } from 'react'
import { StyledIcon } from './styles'

interface ButtonIconProps {
  children: ReactNode
  padding?: string
}
export const ButtonIcon = ({ children, padding }: ButtonIconProps) => {
  return <StyledIcon padding={padding}>{children}</StyledIcon>
}
